import styled from 'styled-components';
import { colors } from "../../../utils/colors";
import cart from '../../../assets/products/cart.svg'
import cartWhite from '../../../assets/products/cartWhite.svg'

export const Product = styled.div`
    width: 100%;
    padding: 10px;
    background: ${colors.WHITE};
    border-radius: 5px;
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.2), 0 3px 4px 0 rgba(0,0,0,.14), 0 1px 8px 0 rgba(0,0,0,.12);
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    animation: buttonsAnimation 500ms ease-in forwards;
    transition: 100ms;

    @media (min-width: 550px) {
        &:hover {
            background: ${colors.CREAM};
        }

        &:hover p {
            color: ${colors.WHITE};
        }

        &:hover button {
            background: url(${cartWhite});
            background-repeat: no-repeat;
            background-position: center;
        }
    }

    @keyframes buttonsAnimation {
        0% {
          opacity: 0;
          transform: scale(0.98);
        }
        100% {
          opacity: 100;
          transform: scale(1);
        }
    }
`;

export const ProductImage = styled.img`
    width: 150px;
    height: 150px;
    margin: 10px auto 0;
    border-radius: 50%;
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),
                0 3px 4px 0 rgba(0,0,0,.14),
                0 1px 8px 0 rgba(0,0,0,.12);
    cursor: pointer;

    @media (max-width: 400px) {
        width: 100px;
        height: 100px;
    }

    @media (max-width: 320px) {
        width: 90%;
        border-radius: 0;
        height: auto;
    }
`;

export const ProductName = styled.p`
    color: ${colors.BLUE};
    // margin: 20px 0;
    font-weight: bold;
    font-size: 22px;
    text-align: center;
    height: 50px;
    cursor: pointer;
    margin: ${(prop) => prop.carousel ? '20px 0 35px' : '20px 0'};

    @media (max-width: 1200px) {
        height: 80px;
    }

    @media (max-width: 400px) {
        font-size: 16px;
    }

    @media (max-width: 320px) {
        font-size: 12px;
    }
`;

export const ProductAlcohol = styled.p`
    color: ${colors.BLUE};
    margin-bottom: 10px;
    text-align: center;
    cursor: pointer;
`;

export const ProductNet = styled.p`
    color: ${colors.BLUE};
    margin-bottom: 10px;
    cursor: pointer;
`;

export const ProductFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    padding: 0 10px;

    @media (max-width: 800px) {
        background: ${colors.CREAM};
        padding: 10px 0;
        border-radius: 10px;
        flex-direction: column;
        gap: 15px;
        height: auto;
    }
`;

export const ProductPrice = styled.p`
    color: ${colors.BLUE};
`;

export const ProductQuantityWrapper = styled.div`
    display: flex;
`;

export const ProductQuantity = styled.p`
    color: ${colors.BLUE};

    @media (max-width: 1200px) {
        display: none;
    }
`;

export const ProductQuantityBox = styled.div`
    display: flex;
    margin-left: 10px;

    @media (max-width: 1200px) {
        margin-left: 0;
    }
`;

export const ProductCart = styled.button`
    background: url(${cart});
    background-repeat: no-repeat;
    background-position: center;
    height: ${(prop) => prop.single ? '30px' : '20px'};
    width: ${(prop) => prop.single ? '30px' : '20px'};
    border: none;
    cursor: pointer;
`;

export const FavoriteIconWrapper = styled.div`
    position: absolute;
    top: 15px;
    left: 15px;
`;

export const InputQuantity = styled.input`
    border: none;
    border-radius: 5px;
    padding-left: 5px;
    color: ${colors.BLUE};
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),
                0 3px 4px 0 rgba(0,0,0,.14),
                0 1px 8px 0 rgba(0,0,0,.12);
`;